import { useState } from "react";
import { TextField, Button, Typography, Container } from "@mui/material";

const CalculateExpense = ({ expenses }) => {
    const [pricePerLitre, setPricePerLitre] = useState("");
    const [totalExpense, setTotalExpense] = useState(null);

    const calculateExpense = () => {
        const totalLitres = expenses.reduce((acc, curr) => acc + curr.quantity, 0);
        setTotalExpense(totalLitres * parseFloat(pricePerLitre));
    };

    return (
        <Container>
            <TextField
                label="Price per Litre"
                type="number"
                fullWidth
                margin="normal"
                value={pricePerLitre}
                onChange={(e) => setPricePerLitre(e.target.value)}
            />
            <Button variant="contained" color="primary" fullWidth onClick={calculateExpense}>
                Calculate
            </Button>
            {totalExpense !== null && (
                <Typography variant="h6" marginTop={2}>
                    Total Expense: ₹{totalExpense.toFixed(2)}
                </Typography>
            )}
        </Container>
    );
};

export default CalculateExpense;
